import type {Middleware} from '@linx-security/api-specs';
import type {Logger} from 'pino';

import {HTTPStatus} from '../types';

import {baseLogger} from './log-middleware';

export const getSessionMiddleware = (base: Logger = baseLogger, onSessionRevoke: (args: Response) => Promise<void>) => {
  const logger = base.child({module: `api`, scope: `session-middleware`}, {});

  return {
    post: async context => {
      if (!context.response) return context.response;

      const {status, statusText, url} = context.response;
      if (HTTPStatus.UNAUTHORIZED !== status) return context.response;

      logger.info(`Got unauthorized response from ${url} ${status} ${statusText}`, context.response);
      logger.info(`Revoking session and redirecting to login page`);
      await onSessionRevoke(context.response);

      return context.response;
    },
  } satisfies Middleware;
};
